export const getFilteredPages = (
	pages,
	detectedLanguages,
	langCode = null
) => {
	if ( ! pages ) return [];

	if ( ! detectedLanguages || ! langCode ) {
		return pages;
	}

	const returnablePages = pages.filter(
		( page ) => page.language === langCode
	);
	if ( returnablePages.length > 0 ) {
		return returnablePages;
	}

	return pages;
};

export const handlePageSelect = (
	value,
	currentValue,
	detectedLanguages,
	langCode = null,
	exceptions = [],
) => {
	// Convert value to integer
	const pageId = parseInt( value, 10 );

	if ( ! detectedLanguages ) {
		return pageId;
	}

	const newValue =
		typeof currentValue === 'object' ? { ...currentValue } : {};

	if ( langCode ) {
		newValue[ langCode ] = pageId;
	}

	if (exceptions.includes('translatePress')) {
        detectedLanguages.forEach((language) => {
            newValue[language] = pageId;
        });
    }

	return newValue;
};

export const getPageForLanguage = (
	dynamicParentPages,
	detectedLanguages,
	langCode = null
) => {
	if ( ! detectedLanguages ) {
		return parseInt( dynamicParentPages, 10 );
	}

	if ( typeof dynamicParentPages !== 'object' ) {
		return 0;
	}

	return parseInt( dynamicParentPages[ langCode ] || 0, 10 );
};

export const getLinkForLanguagePage = (
	dynamicParentPages,
	pages,
	detectedLanguages,
	langCode = null
) => {
	const pageId = getPageForLanguage(
		dynamicParentPages,
		detectedLanguages,
		langCode
	);
	if ( ! pageId || ! pages ) return '#';

	const page = pages.find( ( p ) => p.id === pageId );
	return page ? page.link : '#';
};

export const getTitleForLanguagePage = (
	dynamicParentPages,
	pages,
	detectedLanguages,
	langCode = null
) => {
	const pageId = getPageForLanguage(
		dynamicParentPages,
		detectedLanguages,
		langCode
	);
	if ( ! pageId || ! pages ) return '';

	const page = pages.find( ( p ) => p.id === pageId );
	return page ? page.title.raw : '';
};
